var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProspectsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 43563"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 2342",
    cx: 30.5,
    cy: 30,
    r: 30,
    fill: "#0044AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M36.2366 32.9108H34.7098C36.5378 31.0087 37.6673 28.4301 37.6673 25.5837C37.6673 19.7385 32.9288 15 27.0837 15C21.2385 15 16.5 19.7385 16.5 25.5837C16.5 31.4288 21.2385 36.1673 27.0837 36.1673C29.1841 36.1673 31.1364 35.5478 32.7826 34.4926V36.3649L41.4177 45L44.8717 41.5459L36.2366 32.9108ZM32.4939 30.4818C31.7342 29.7052 30.3595 29.1066 28.6577 28.8769C28.5404 28.6594 28.4732 28.416 28.4732 28.1591C28.4732 27.9278 28.5418 27.7118 28.6404 27.5081C29.5169 26.91 30.1083 25.8366 30.1083 24.5991C30.1083 22.7148 28.7506 21.1874 27.0756 21.1874C25.4006 21.1874 24.0429 22.7148 24.0429 24.5991C24.0429 25.8366 24.6343 26.91 25.5109 27.5081C25.6094 27.7118 25.678 27.9278 25.678 28.1591C25.678 28.416 25.6109 28.6594 25.4936 28.8769C23.7979 29.1057 22.4284 29.7012 21.6669 30.4738C20.4923 29.1739 19.7565 27.4694 19.7565 25.5837C19.7565 21.5434 23.0434 18.2565 27.0837 18.2565C31.1239 18.2565 34.4108 21.5434 34.4108 25.5837C34.4108 27.4732 33.6725 29.1811 32.4939 30.4818Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProspectsIcon);
export default __webpack_public_path__ + "static/media/prospectsIcon.48f2e9f1f3c78cb6a8c5b836d5e6b39b.svg";
export { ForwardRef as ReactComponent };